import { c as _c } from "react/compiler-runtime";
import { useState, useMemo, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { uniq } from 'lodash';
import getProductImageAngle from 'commons/getProductImageAngle';
import contructHeroImageForNonConfigurableProduct from 'commons/contructHeroImageForNonConfigurableProduct';
import { IMAGE_FLIP_ORIENTATION_VALUES } from 'commons/constants';
import usePdpLastHoveredOptionsExtended from 'components/consumer/PDP/state/pdpLastHoveredOptionsExtended/usePdpLastHoveredOptionsExtended';
import usePdpLastHoveredVariantSku from 'components/consumer/PDP/state/pdpLastHoveredVariantSku';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePdpSelectedOptionsVariantSku from 'components/consumer/PDP/state/pdpSelectedOptionsVariantSku/usePdpSelectedOptionsVariantSku';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useScreen from '../../hooks/useScreen';
import { getOptionFromOptionName, getOptionValueFromValueName, getConfigPhotosForSelectedOptions } from './utils';
const usePDPPhotos = () => {
  const $ = _c(82);
  const {
    isDesktop
  } = useScreen();
  const {
    loading: basicDetailsLoading,
    error: basicDetailsError,
    data: t0
  } = usePDPBasicDetails();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const basicDetails = t1;
  const {
    imgsloading: optionLoading,
    error: optionError,
    data: t2
  } = usePDPOptions();
  let t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const optionData = t3;
  const [isVideoSelected, setIsVideoSelected] = useState(false);
  const {
    search
  } = useLocation();
  let t4;
  if ($[4] !== search) {
    t4 = new URLSearchParams(search)?.get("fabric")?.replace("-", "_")?.toLowerCase() ?? "";
    $[4] = search;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const fabric = t4;
  const {
    hasOrientation,
    options,
    pdpHasUserSelectedOptions,
    selectedOptions,
    selectedOptionsExtended,
    upholsteryOptionId
  } = optionData;
  const selectedOptionsVariantSku = usePdpSelectedOptionsVariantSku();
  let t5;
  if ($[6] !== basicDetails) {
    t5 = basicDetails ?? {};
    $[6] = basicDetails;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    defaultAngle: productDefaultAngle,
    hero_images: heroImages,
    id: productId,
    name: productName,
    type: productType,
    variation_photos_count: productVariationPhotosCount
  } = t5;
  let t6;
  if ($[8] !== productDefaultAngle || $[9] !== productType) {
    t6 = {
      defaultAngle: productDefaultAngle,
      type: productType
    };
    $[8] = productDefaultAngle;
    $[9] = productType;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const basicDetailsForImageAngle = t6;
  let t7;
  bb0: {
    if (!heroImages || !options) {
      let t8;
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = [];
        $[11] = t8;
      } else {
        t8 = $[11];
      }
      t7 = t8;
      break bb0;
    }
    let t8;
    if ($[12] !== basicDetailsForImageAngle || $[13] !== fabric || $[14] !== heroImages || $[15] !== options || $[16] !== pdpHasUserSelectedOptions || $[17] !== productId || $[18] !== productName || $[19] !== selectedOptions || $[20] !== upholsteryOptionId) {
      const productAngle = getProductImageAngle({
        product: basicDetailsForImageAngle
      });
      const allImages = heroImages?.length ? heroImages.filter(_temp).map(t9 => {
        const {
          img: t10,
          upholstery_name,
          upholstery_type
        } = t9;
        const {
          url,
          cropData: t11
        } = t10;
        const cropData = t11 === undefined ? {} : t11;
        const option = getOptionFromOptionName(options, upholstery_type);
        const value = getOptionValueFromValueName(option, upholstery_name);
        return {
          id: url,
          src: url,
          type: "studio",
          cropData,
          upholsteryName: upholstery_name,
          upholsteryType: upholstery_type,
          optionId: option?.id,
          valueId: value?.id
        };
      }) : [{
        id: 1,
        src: contructHeroImageForNonConfigurableProduct(productName, productId, productAngle).transparent_hero_image_ts,
        type: "studio",
        cropData: null,
        upholsteryName: null,
        upholsteryType: null,
        optionId: null,
        valueId: null
      }];
      const imagesOfFabricFromUrl = fabric ? allImages.filter(photo => photo?.upholsteryName?.toLowerCase().replace(" ", "_") === fabric) : [];
      const selectedUpholsteryValueId = pdpHasUserSelectedOptions && selectedOptions && upholsteryOptionId ? selectedOptions[upholsteryOptionId] : null;
      const currentSelectionImages = upholsteryOptionId ? allImages.filter(t12 => {
        const {
          optionId,
          valueId
        } = t12;
        return `${upholsteryOptionId}` === `${optionId}` && `${selectedUpholsteryValueId}` === `${valueId}`;
      }) : [];
      t8 = uniq([...currentSelectionImages, ...imagesOfFabricFromUrl, ...allImages]);
      $[12] = basicDetailsForImageAngle;
      $[13] = fabric;
      $[14] = heroImages;
      $[15] = options;
      $[16] = pdpHasUserSelectedOptions;
      $[17] = productId;
      $[18] = productName;
      $[19] = selectedOptions;
      $[20] = upholsteryOptionId;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    t7 = t8;
  }
  const studioPhotos = t7;
  const customProperties = basicDetails?.custom_properties;
  const dimensionalImageDesktop = customProperties?.dimensional_image_desktop;
  const dimensionalImageMobile = customProperties?.dimensional_image_mobile;
  const introVideoMobile = customProperties?.video_1x1 && customProperties?.video_1x1 !== "" ? customProperties?.video_1x1 : customProperties?.intro_video_1x1;
  const introVideoDesktop = customProperties?.video_3x2 && customProperties?.video_3x2 !== "" ? customProperties?.video_3x2 : customProperties?.intro_video_16x9;
  let t8;
  bb1: {
    if (!customProperties) {
      t8 = null;
      break bb1;
    }
    const image = isDesktop ? dimensionalImageDesktop : dimensionalImageMobile;
    let t9;
    if ($[22] !== image) {
      t9 = image ? {
        id: 1,
        src: image,
        type: "dimensional"
      } : null;
      $[22] = image;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    t8 = t9;
  }
  const dimensionalImage = t8;
  let t9;
  bb2: {
    if (!customProperties) {
      t9 = null;
      break bb2;
    }
    if (introVideoDesktop && introVideoMobile) {
      let t10;
      if ($[24] !== introVideoDesktop || $[25] !== introVideoMobile) {
        t10 = {
          desktop: introVideoDesktop,
          mobile: introVideoMobile
        };
        $[24] = introVideoDesktop;
        $[25] = introVideoMobile;
        $[26] = t10;
      } else {
        t10 = $[26];
      }
      t9 = t10;
      break bb2;
    }
    if (introVideoDesktop && !introVideoMobile) {
      let t10;
      if ($[27] !== introVideoDesktop) {
        t10 = {
          desktop: introVideoDesktop,
          mobile: introVideoDesktop
        };
        $[27] = introVideoDesktop;
        $[28] = t10;
      } else {
        t10 = $[28];
      }
      t9 = t10;
      break bb2;
    }
    if (!introVideoDesktop && introVideoMobile) {
      let t10;
      if ($[29] !== introVideoMobile) {
        t10 = {
          desktop: introVideoMobile,
          mobile: introVideoMobile
        };
        $[29] = introVideoMobile;
        $[30] = t10;
      } else {
        t10 = $[30];
      }
      t9 = t10;
      break bb2;
    }
    t9 = null;
  }
  const introVideoIds = t9;
  let t10;
  if ($[31] !== productId || $[32] !== productName || $[33] !== productType || $[34] !== productVariationPhotosCount) {
    t10 = {
      id: productId,
      name: productName,
      type: productType,
      variation_photos_count: productVariationPhotosCount
    };
    $[31] = productId;
    $[32] = productName;
    $[33] = productType;
    $[34] = productVariationPhotosCount;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  const basicDetailsForImageUtils = t10;
  let t11;
  bb3: {
    if (!selectedOptions || !productId) {
      let t12;
      if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = [];
        $[36] = t12;
      } else {
        t12 = $[36];
      }
      t11 = t12;
      break bb3;
    }
    let t12;
    if ($[37] !== basicDetailsForImageUtils || $[38] !== selectedOptionsExtended || $[39] !== selectedOptionsVariantSku || $[40] !== upholsteryOptionId) {
      t12 = getConfigPhotosForSelectedOptions(selectedOptionsVariantSku, selectedOptionsExtended, upholsteryOptionId, basicDetailsForImageUtils);
      $[37] = basicDetailsForImageUtils;
      $[38] = selectedOptionsExtended;
      $[39] = selectedOptionsVariantSku;
      $[40] = upholsteryOptionId;
      $[41] = t12;
    } else {
      t12 = $[41];
    }
    const updatedConfigurationPhotos = t12;
    t11 = updatedConfigurationPhotos;
  }
  const configurationPhotos = t11;
  let t12;
  bb4: {
    if (!selectedOptions || !productId || !selectedOptionsVariantSku && configurationPhotos.length) {
      t12 = false;
      break bb4;
    }
    let t13;
    if ($[42] !== hasOrientation) {
      t13 = hasOrientation || {};
      $[42] = hasOrientation;
      $[43] = t13;
    } else {
      t13 = $[43];
    }
    const {
      optionId: orientationOptionId,
      defaultValueId: orientationDefaultValueId
    } = t13;
    if (orientationOptionId && orientationDefaultValueId) {
      let t14;
      if ($[44] !== orientationOptionId || $[45] !== selectedOptionsExtended) {
        const selectedOptionValue = selectedOptionsExtended[orientationOptionId]?.value?.value.toLowerCase().split(" ").join("_");
        t14 = IMAGE_FLIP_ORIENTATION_VALUES.includes(selectedOptionValue);
        $[44] = orientationOptionId;
        $[45] = selectedOptionsExtended;
        $[46] = t14;
      } else {
        t14 = $[46];
      }
      const isImageFlipped = t14;
      t12 = isImageFlipped;
      break bb4;
    }
    t12 = false;
  }
  const isConfigFlipped = t12;
  const [userSelectedPhoto, setUserSelectedPhoto] = useState(null);
  let t13;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = photoOrCallback => {
      setUserSelectedPhoto(photoOrCallback);
      setIsVideoSelected(false);
    };
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  const selectPhoto = t13;
  let t14;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => {
      setUserSelectedPhoto(null);
      setIsVideoSelected(true);
    };
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  const selectVideo = t14;
  let t15;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => {
      setUserSelectedPhoto(null);
    };
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  let t16;
  if ($[50] !== productId) {
    t16 = [productId];
    $[50] = productId;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  useEffect(t15, t16);
  const pdpLastHoveredOptionsExtended = usePdpLastHoveredOptionsExtended();
  const pdpLastHoveredVariantSku = usePdpLastHoveredVariantSku();
  let t17;
  bb5: {
    if (pdpLastHoveredVariantSku) {
      let t18;
      if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = [];
        $[52] = t18;
      } else {
        t18 = $[52];
      }
      t17 = t18;
      break bb5;
    }
    let t18;
    if ($[53] !== basicDetailsForImageUtils || $[54] !== pdpLastHoveredOptionsExtended || $[55] !== pdpLastHoveredVariantSku || $[56] !== upholsteryOptionId) {
      t18 = getConfigPhotosForSelectedOptions(pdpLastHoveredVariantSku, pdpLastHoveredOptionsExtended, upholsteryOptionId, basicDetailsForImageUtils);
      $[53] = basicDetailsForImageUtils;
      $[54] = pdpLastHoveredOptionsExtended;
      $[55] = pdpLastHoveredVariantSku;
      $[56] = upholsteryOptionId;
      $[57] = t18;
    } else {
      t18 = $[57];
    }
    const updatedLastHoveredConfigPhotos = t18;
    t17 = updatedLastHoveredConfigPhotos;
  }
  const lastHoveredConfigPhotos = t17;
  let t18;
  bb6: {
    const defaultImage = configurationPhotos[0] ?? studioPhotos[0];
    const selectedPhotoType = userSelectedPhoto?.type;
    if (selectedPhotoType === "cylindo") {
      t18 = userSelectedPhoto;
      break bb6;
    }
    const selectedPhotoSrc = userSelectedPhoto?.src;
    if (selectedPhotoType === "configuration" && configurationPhotos.length) {
      let t19;
      if ($[58] !== configurationPhotos || $[59] !== defaultImage || $[60] !== selectedPhotoSrc) {
        t19 = configurationPhotos.find(photo_0 => selectedPhotoSrc && photo_0?.src === selectedPhotoSrc) ?? configurationPhotos[0] ?? defaultImage;
        $[58] = configurationPhotos;
        $[59] = defaultImage;
        $[60] = selectedPhotoSrc;
        $[61] = t19;
      } else {
        t19 = $[61];
      }
      t18 = t19;
      break bb6;
    }
    if (selectedPhotoType === "studio" && studioPhotos.length) {
      let t19;
      if ($[62] !== defaultImage || $[63] !== selectedPhotoSrc || $[64] !== studioPhotos) {
        t19 = studioPhotos.find(photo_1 => selectedPhotoSrc && photo_1?.src === selectedPhotoSrc) ?? studioPhotos[0] ?? defaultImage;
        $[62] = defaultImage;
        $[63] = selectedPhotoSrc;
        $[64] = studioPhotos;
        $[65] = t19;
      } else {
        t19 = $[65];
      }
      t18 = t19;
      break bb6;
    }
    if (selectedPhotoType === "dimensional") {
      t18 = userSelectedPhoto;
      break bb6;
    }
    t18 = defaultImage;
  }
  const selectedPhoto = t18;
  const t19 = basicDetailsLoading || optionLoading;
  const t20 = basicDetailsError || optionError;
  const t21 = basicDetails?.custom_properties?.campaign;
  let t22;
  if ($[66] !== configurationPhotos || $[67] !== dimensionalImage || $[68] !== introVideoIds || $[69] !== isConfigFlipped || $[70] !== isVideoSelected || $[71] !== lastHoveredConfigPhotos || $[72] !== productName || $[73] !== selectedPhoto || $[74] !== studioPhotos || $[75] !== t21) {
    t22 = {
      campaign: t21,
      configurationPhotos,
      dimensionalImage,
      enableCrops: true,
      introVideoIds,
      isConfigFlipped,
      isVideoSelected,
      lastHoveredConfigPhotos,
      productName,
      selectedPhoto,
      studioPhotos
    };
    $[66] = configurationPhotos;
    $[67] = dimensionalImage;
    $[68] = introVideoIds;
    $[69] = isConfigFlipped;
    $[70] = isVideoSelected;
    $[71] = lastHoveredConfigPhotos;
    $[72] = productName;
    $[73] = selectedPhoto;
    $[74] = studioPhotos;
    $[75] = t21;
    $[76] = t22;
  } else {
    t22 = $[76];
  }
  let t23;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      setSelectedPhoto: selectPhoto,
      setIsVideoSelected: selectVideo
    };
    $[77] = t23;
  } else {
    t23 = $[77];
  }
  let t24;
  if ($[78] !== t19 || $[79] !== t20 || $[80] !== t22) {
    t24 = {
      loading: t19,
      error: t20,
      data: t22,
      actions: t23
    };
    $[78] = t19;
    $[79] = t20;
    $[80] = t22;
    $[81] = t24;
  } else {
    t24 = $[81];
  }
  return t24;
};
export default usePDPPhotos;
function _temp(hero) {
  return hero?.img?.url;
}